const InitialState = {
	machineID: "",
	location: "",
	kitchenId: "",
	restaurantTimeZone: "",
	machines: null,
};

export const landing = (state = InitialState, action) => {
	switch (action.type) {
		case "SET_MACHINE_ID":
			return {
				...state,
				machineID: action.data._id,
				location: action.data.name,
				kitchenId: action.data.kitchenId,
				restaurantTimeZone: action.data.timeZone || "",
			};

		case "SET_MACHINES":
			return {
				...state,
				machines: action.data,
			};

		default:
			return {
				...state,
			};
	}
};

export default landing;
